import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-form-ricorso-cassazione-view',
  templateUrl: './form-ricorso-cassazione-view.component.html',
  styleUrls: ['./form-ricorso-cassazione-view.component.css']
})
export class FormRicorsoCassazioneViewComponent {

  @Input() ctxBodyFascicolo;
  constructor() {}
}
